import script from "./SnailMail.vue?vue&type=script&setup=true&lang=js"
export * from "./SnailMail.vue?vue&type=script&setup=true&lang=js"

import "./SnailMail.vue?vue&type=style&index=0&id=7267b4f6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7267b4f6"]])

export default __exports__